<template>
  <el-dialog
    append-to-body
    class="rtportal rt-common-dialog big-dialog app-content"
    :close-on-click-modal="false"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
  >
    <el-row>
      <!-- <el-col :span="4">搜索</el-col> -->
      <el-col :span="24">
        <el-input
          v-model="filterValue"
          @keyup.enter.native="handleSearch"
          :placeholder="searchPlaceholder"
        >
          <el-button
            type="text"
            slot="append"
            icon="el-icon-search"
            style="margin-top:-12px;"
            @click="handleSearch"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      ref="dataTable"
      style="width: 100%"
      height="470px"
      :row-class-name="tabRowClassName"
      highlight-current-row
      :header-cell-style="{background:'#F8F9FA'}"
      v-bind:data="filteredData"
      border
      stripe
      @current-change="handleCurrentChange"
      @row-dblclick="handleConfirm"
      v-loading="loading"
    >
      <el-table-column width="55">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row == currentRow"></i>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        v-for="display in displayFields"
        v-bind:key="display.name"
        :prop="display.name"
        :label="display.label"
        :width="display.width"
      ></el-table-column>
      <template slot="empty">
        <img style="margin-top:50px;" src="../../../src/assets/imgs/home/no-order.png" alt />
        <p class="nodata-prompt">哎呀，暂时没有内容哦～</p>
      </template>
    </el-table>
    <div slot="footer" class='pagination-wrap'>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleIndexChange"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="totalRecordCount"
        style="margin-bottom:10px;text-align: center;"
      ></el-pagination>
      <span class="dialog-footer">
        <el-button @click="handleReset">移除值</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RtCommonDialog",
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    displayFields: {
      type: Array,
      default: () => [
        { name: "Vehicle", label: "规格型号" },
        { name: "new_product_name", label: "产品名称" },
        { name: "new_product_line", label: "产品线" }
      ]
    },
    dialogTitle: {
      type: String,
      default: "列表选择"
    },
    searchPlaceholder: {
      type: String,
      default: "搜索内容"
    },
    valueField: {
      type: String,
      default: "Vehicle" // 默认返回 Vehicle 字段的值
    },
    currentValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      
      filterValue: "",
      
      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,
      
      filteredAllData: [], // 过滤后的所有数据
      filteredData: [], // 当前页显示的数据
      currentRow: null
    };
  },
  watch: {
    dataSource: {
      handler(newData) {
        this.updateFilteredData();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "even-row";
      }
    },
    show() {
      this.dialogVisible = true;
      this.filterValue = "";
      this.pageIndex = 1;
      this.updateFilteredData();
      
      // 回显当前选中项
      this.$nextTick(() => {
        this.setCurrentRowByValue();
      });
    },
    // 根据当前值设置选中行
    setCurrentRowByValue() {
      if (this.currentValue && this.filteredAllData.length > 0) {
        // 在所有过滤数据中查找匹配的行
        const matchedRow = this.filteredAllData.find(item => 
          item[this.valueField] === this.currentValue
        );
        
        if (matchedRow) {
          // 计算匹配行在第几页
          const matchedIndex = this.filteredAllData.indexOf(matchedRow);
          const targetPage = Math.floor(matchedIndex / this.pageSize) + 1;
          
          // 如果不在当前页，需要跳转到对应页
          if (targetPage !== this.pageIndex) {
            this.pageIndex = targetPage;
            this.updatePaginatedData();
            
            this.$nextTick(() => {
              this.setCurrentRowInTable(matchedRow);
            });
          } else {
            this.setCurrentRowInTable(matchedRow);
          }
        }
      }
    },
    // 在表格中设置当前行
    setCurrentRowInTable(row) {
      this.currentRow = row;
      if (this.$refs.dataTable) {
        this.$refs.dataTable.setCurrentRow(row);
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.updateFilteredData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageIndex = 1;
      this.updatePaginatedData();
    },
    handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.updatePaginatedData();
      
      // 翻页后需要重新设置当前选中行
      this.$nextTick(() => {
        this.setCurrentRowAfterPageChange();
      });
    },
    // 翻页后设置当前选中行
    setCurrentRowAfterPageChange() {
      if (this.currentValue && this.filteredData.length > 0) {
        const matchedRow = this.filteredData.find(item => 
          item[this.valueField] === this.currentValue
        );
        
        if (matchedRow) {
          this.setCurrentRowInTable(matchedRow);
        }
      }
    },
    handleReset() {
      this.$emit("item-selected", "");
      this.dialogVisible = false;
    },
    handleConfirm() {
      var selectedRow = this.$refs.dataTable.store.states.currentRow;
      if (!selectedRow) {
        this.$message.error("请选择一条记录");
        return;
      }

      // 返回指定字段的值
      const selectedValue = selectedRow[this.valueField];
      this.$emit("item-selected", selectedValue, selectedRow);
      this.dialogVisible = false;
    },
    // 更新过滤后的数据
    updateFilteredData() {
      if (!this.dataSource || this.dataSource.length === 0) {
        this.filteredAllData = [];
        this.totalRecordCount = 0;
        this.filteredData = [];
        return;
      }

      // 如果没有搜索条件，显示所有数据
      if (!this.filterValue.trim()) {
        this.filteredAllData = [...this.dataSource];
      } else {
        // 根据搜索条件过滤数据（在所有显示字段中搜索）
        const searchValue = this.filterValue.toLowerCase().trim();
        this.filteredAllData = this.dataSource.filter(item => {
          return this.displayFields.some(field => {
            const fieldValue = (item[field.name] || "").toString().toLowerCase();
            return fieldValue.includes(searchValue);
          });
        });
      }
      
      this.totalRecordCount = this.filteredAllData.length;
      this.updatePaginatedData();
    },
    // 更新分页数据
    updatePaginatedData() {
      const start = (this.pageIndex - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.filteredData = this.filteredAllData.slice(start, end);
      
      this.$nextTick(() => {
        if (this.$refs.dataTable) {
          this.$refs.dataTable.doLayout();
        }
      });
    }
  }
};
</script>

<style scoped>
.rt-common-dialog .el-dialog {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 800px;
  margin: 0px !important;
}

.rt-common-dialog .el-table {
  margin-top: 15px;
  box-sizing: border-box;
}

.rt-common-dialog .el-dialog__body {
  padding-bottom: 15px;
}

.big-dialog .el-row {
  padding: 15px 20px 0 15px;
  line-height: 2;
  color: #143e81 !important;
}

.el-icon-circle-check:before {
  display: none !important;
}

.el-input__validateIcon {
  display: none !important;
}

.nodata-prompt {
  color: #999;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// common-dialog.vue?7a2c22ae